import TSkeleton from './skeleton.vue'

TSkeleton.install = Vue => {
  Vue.component(TSkeleton.name, TSkeleton)
}

export default TSkeleton



// WEBPACK FOOTER //
// ./src/module/skeleton/index.js